import Component from '@glimmer/component';
import { ICONS_LOGOS_MAP } from '@mylighthouse/prism-logo';
import { Illustration } from 'frontend-utils';
import aibosolutionsLogo from 'lumen/assets/images/white-label/aibosolutions-logo.svg?raw';
import bwOptimizerLogo from 'lumen/assets/images/white-label/BWOptimizer-logo.svg?raw';
import hotelBiznessLogo from 'lumen/assets/images/white-label/HotelBizness-logo.svg?raw';
import hotellabioLogo from 'lumen/assets/images/white-label/hotellabio-logo.svg?raw';
import iforhospitalityLogo from 'lumen/assets/images/white-label/iforhospitality-logo.svg?raw';
import IHCLLogo from 'lumen/assets/images/white-label/IHCL-logo.svg?raw';
import jhmHotelsLogo from 'lumen/assets/images/white-label/JHMHotels-logo.svg?raw';
import omnibeesLogo from 'lumen/assets/images/white-label/omnibees-logo.svg?raw';
import rateboardLogo from 'lumen/assets/images/white-label/rateboard-logo.svg?raw';
import revenueclLogo from 'lumen/assets/images/white-label/revenuecl-logo.svg?raw';
import semperLogo from 'lumen/assets/images/white-label/semper-logo.svg?raw';
import smartplanetLogo from 'lumen/assets/images/white-label/smartplanet-logo.svg?raw';
import taLogo from 'lumen/assets/images/white-label/TA-PoweredBy.svg?raw';
import tagreenLogo from 'lumen/assets/images/white-label/TA-PoweredBy-green.svg?raw';
import thinkinLogo from 'lumen/assets/images/white-label/thinkin-logo.svg?raw';
import tirolLogo from 'lumen/assets/images/white-label/tirol-logo.svg?raw';
import tripadvisorLogo from 'lumen/assets/images/white-label/tripadvisor-logo.svg?raw';

interface GeneralHeaderLogoSignature {
  Args: {
    reseller?: string;
  };
}

export default class HeaderLogo extends Component<GeneralHeaderLogoSignature> {
  get resellerLogo(): string | null {
    switch (this.args.reseller) {
      case 'aibosolutions':
        return aibosolutionsLogo;
      case 'bwoptimizer':
        return bwOptimizerLogo;
      case 'HotelBizness':
        return hotelBiznessLogo;
      case 'hotellabio':
        return hotellabioLogo;
      case 'iforhospitality':
        return iforhospitalityLogo;
      case 'ihcl':
        return IHCLLogo;
      case 'JHMHotels':
        return jhmHotelsLogo;
      case 'omnibees':
        return omnibeesLogo;
      case 'rateboard':
        return rateboardLogo;
      case 'revenuecl':
        return revenueclLogo;
      case 'semper':
        return semperLogo;
      case 'smartplanet':
        return smartplanetLogo;
      case 'TA-PoweredBy-green':
        return tagreenLogo;
      case 'TA-PoweredBy':
        return taLogo;
      case 'thinkin':
        return thinkinLogo;
      case 'tirol':
        return tirolLogo;
      case 'tripadvisor':
        return tripadvisorLogo;
      default:
        return null;
    }
  }

  <template>
    {{#if this.resellerLogo}}
      <a class="flex" href=".">
        <Illustration
          @html={{this.resellerLogo}}
          class="platform-logo white-label"
        />
      </a>

      <div class="poweredby">
        {{! template-lint-disable no-bare-strings }}
        <span class="poweredby__text">Powered by</span>
        <Illustration @html={{ICONS_LOGOS_MAP.logo-dark}} class="logo" />
      </div>
    {{else}}
      <Illustration
        @html={{ICONS_LOGOS_MAP.logo-color}}
        class="platform-logo"
      />
    {{/if}}
  </template>
}
